import React, { useCallback, useEffect, useState } from "react";
import Button from "../../../components/form/Button";
import Input from "../../../components/form/Input";
import { formValidate } from "../../../helpers/formValidate";
import useForm from "../../../hooks/useForm";
import { Validation } from "../../../helpers/Validation";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { addShippingAddress, getStateList, userDetails } from "../../../services/userService";
import SelectDropdownSearch from "../../../components/form/SelectDropdownSearch";

export const AddEditUserShippingAddressModal = ({
  onClose = () => {},
  id,
  data,
  // loaded,
  // setLoaded = () => {},
  setShippingDetails = () => {},
  getShippingDetails = () => {},
}) => {
  const validation = {
    location: { required: true, message: "Please enter your location !!!" },
    city: { required: true, message: "Please enter city !!!" },
    pin: { required: true, message: "Please enter pin number !!!" },
    state: { required: true, message: "Please enter state !!!" },
  };
  const { values, handleChange, handleSubmit, errors, setFieldsValue } = useForm({}, validation);
  const navigate = useNavigate();
  const [stateKeyword, setStateKeyword] = useState("");
  const [stateList, setStateList] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const [detailsData, setDetailsData] = useState({ loading: false, data: {} });

  const onSubmit = async (values) => {
    setLoaded(true);
    try {
      const res = await addShippingAddress({
        id: detailsData?.data?.userShippingAddressInfo?.id,
        user_id: id,
        location: values?.location,
        city: values?.city || "",
        pin: values?.pin || "",
        state: values?.state?._id,
      });
      if (res?.data?.status === 200 || res?.data?.status === 201) {
        onClose(true);
        // setShippingDetails(res?.data);
        getShippingDetails();
        toast.info(res?.data?.message);
      } else {
        toast.info(res?.data?.message || res?.data?.errors || "Something went wrong");
      }

      setLoaded(false);
    } catch (err) {
      setLoaded(false);
      // console.error(err);
      toast.error("Somthing went wrong !!!");
    }
  };

  const getDetails = useCallback(() => {
    if (id) {
      setDetailsData({ loading: true, data: {} });
      userDetails({ id }).then((res) => {
        if (res?.status === 200) {
          setDetailsData({ loading: true, data: res?.docs });
          setFieldsValue({
            location: res?.docs?.userShippingAddressInfo?.location || "",
            city: res?.docs?.userShippingAddressInfo?.city || "",
            state:
              {
                name: res?.docs?.userShippingAddressInfo?.stateInfo
                  ? res?.docs?.userShippingAddressInfo?.stateInfo
                  : null,
                _id: res?.docs?.userShippingAddressInfo?.stateInfo?.id
                  ? res?.docs?.userShippingAddressInfo?.stateInfo?.id
                  : null,
              } || "",
            pin: res?.docs?.userShippingAddressInfo?.pin || "",
          });
        }
      });
    }
  }, [id]);

  useEffect(() => {
    getDetails();
  }, [getDetails]);

  // loading the State list >>>>>>>>>
  const loadStateList = useCallback(() => {
    getStateList({
      keyword: stateKeyword,
      perPage: 9999999999,
    }).then((res) => {
      if (res && res?.success) {
        setStateList(res?.data);
      }
    });
  }, [stateKeyword]);

  useEffect(() => {
    loadStateList();
  }, [loadStateList]);

  return (
    <div>
      <form onSubmit={(event) => handleSubmit(event, onSubmit)}>
        <div className="py-2">
          <div className="grid grid-cols-5 gap-4 divide-x divide-slate-200 md:px-5 px-0">
            <div className="xl:col-span-12 col-span-5">
              <div className="space-y-3">
                <div className="grid grid-cols-12 gap-4">
                  <div className="relative md:col-span-12 col-span-12">
                    <Input
                      isInputGroup={true}
                      label={"Location"}
                      labelClasses={"!text-base !text-slate-600"}
                      inputClasses={"!border-slate-400"}
                      inputType={"text"}
                      value={values.location}
                      inputName={"location"}
                      onChange={handleChange}
                      inputPlaceholder={"Enter Location"}
                      {...formValidate(errors, "location")}
                    />
                  </div>
                  <div className="relative md:col-span-6 col-span-12">
                    <div className="relative col-span-6">
                      <SelectDropdownSearch
                        label={"Province "}
                        placeholder={"Select a province "}
                        xPlacement={"bottom"}
                        buttonArrowIcon={""}
                        selectName={"state"}
                        isSearch={true}
                        dropdownButtonClass="!px-3 !border-slate-400 !w-full"
                        labelClasses={"!text-base !text-slate-600"}
                        onChange={handleChange}
                        onSearch={(key) => setStateKeyword(key)}
                        value={values?.state}
                        dropdownData={stateList?.map((item) => ({
                          name: item?.name,
                          _id: item?.id,
                        }))}
                        //   {...formValidate(errors, "state")}
                      />
                    </div>
                  </div>
                  <div className="relative md:col-span-6 col-span-12">
                    <Input
                      isInputGroup={true}
                      label={"City"}
                      inputPlaceholder={"Enter  City"}
                      labelClasses={"!text-base !text-slate-600"}
                      inputClasses={"!border-slate-400"}
                      inputType={"city"}
                      value={values.city}
                      inputName={"city"}
                      onChange={handleChange}
                      {...formValidate(errors, "city")}
                    />
                  </div>
                  <div className="relative md:col-span-6 col-span-12">
                    <Input
                      isInputGroup={true}
                      label={"Postal Code"}
                      inputPlaceholder={"Enter Postal Code"}
                      labelClasses={"!text-base !text-slate-600"}
                      inputClasses={"!border-slate-400"}
                      inputType={"text"}
                      value={values.pin}
                      inputName={"pin"}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-8 pt-4 border-t border-slate-200">
            <div className="flex justify-end space-x-3">
              <Button
                buttonHasLink={false}
                buttonLink={""}
                buttonType={"button"}
                buttonIcon={"fa-regular fa-xmark"}
                buttonIconPosition={"left"}
                buttonFunction={onClose}
                buttonLabel={"Cancel"}
                buttonClasses={"!bg-white !text-primary !border-primary !border-2"}
              />
              <Button
                buttonHasLink={false}
                buttonType={"submit"}
                buttonIcon={"fa-light fa-floppy-disk"}
                buttonIconPosition={"left"}
                buttonClasses={"!bg-primary !text-org-silver"}
                buttonLabel={"Save"}
                isDisable={loaded}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
